import MenuTop from "../../../../components/menu/top/menu-top";
import Form from "../../../../components/form/form";
import storage from "../../../../shared/services/storage";
import InfoComponent from "../../../../components/info/info";
import { useCallback, useEffect, useState } from "react";
import { fetchUserCompanyService, fetchCompaniesService as getCompanies } from "../../../../features/company/service/company";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../../../components/alert/alert";
import { SEVERITY } from "../../../../shared/interfaces/alert";
import { FormProps } from "../../../../shared/interfaces/form";
import './style.css';
import beneficiaryData from "../../../../features/beneficiary/forms/beneficiary-data";
import { createBeneficiaryService, fetchBeneficiaryTypesService } from "../../../../features/beneficiary/service/beneficiary-service";
import { Beneficiary } from "../../../../shared/interfaces/beneficiary";

function BeneficiaryAdd() {
    const navigate = useNavigate();
    const { showAlert } = useAlert();
    const [ formData, setFormData ] = useState<FormProps[] | any>();
    const [ isLoading, setIsLoading ] = useState<boolean>(true);
    const [ isSubmitting, setIsSubmitting ] = useState<boolean>(false);
    const [ companyId, setCompanyId ] = useState<string | null>(null);
    const [ userCompany, setUserCompany ] = useState<any>(null);

    const fetchBeneficiaryTypes = useCallback(async () => {
        try {
            const response = await fetchBeneficiaryTypesService();

            return response?.map(({ name, id}: any) => ({ label: name, value: id }));
        } catch (error) {
            console.error("Erro ao buscar financiadores:", error);
            return [];
        }
    }, []);

    const fetchListCompanies = useCallback(async () => {
        try {
            const response = await getCompanies();
            return response?.map(({ name, id}: any) => ({ label: name, value: id }));
        } catch (error) {
            console.error("Erro ao buscar empresas:", error);
            return [];
        }
    }, []);

    const fetchUserCompany = useCallback(async () => {
        try {
            const userLogged = await storage.getStorage('user');
            if (!userLogged) return null;

            const companyId = JSON.parse(userLogged).company.id;
            return await fetchUserCompanyService(companyId);
        } catch (error) {
            console.error("Erro ao buscar empresa do usuário:", error);
            return null;
        }
    }, []);

    const fetchAllData = useCallback(async () => {
        setIsLoading(true);
        try {
            try {
                const user = await storage.getStorage('user');
                if (user) {
                    const userData = JSON.parse(user);
                    if (userData && userData.company && userData.company.id) {
                        setCompanyId(userData.company.id);
                    }
                }
            } catch (error) {
                console.error("Erro ao obter dados do usuário:", error);
            }
            
            const [beneficiaryTypes, companies, userCompany] = await Promise.all([
                fetchBeneficiaryTypes(),
                fetchListCompanies(),
                fetchUserCompany()
            ]);

            const initialFormData = beneficiaryData(
                undefined,
                undefined,
                companies,
                beneficiaryTypes,
                userCompany
            );

            setUserCompany(userCompany);
            setFormData(initialFormData);
        } catch (error) {
            console.error("Erro ao carregar dados do projeto:", error);
            showAlert('Erro ao carregar dados do projeto', SEVERITY.ERROR);
        } finally {
            setIsLoading(false);
        }
    }, [fetchBeneficiaryTypes, fetchListCompanies, fetchUserCompany, showAlert]);

    const onSubmitForm = async (data: Beneficiary) => {
        if (isSubmitting) return;
        
        setIsSubmitting(true);
        setIsLoading(true);
        
        try {            

            if (userCompany?.name?.toLocaleLowerCase() !== 'causale') {
                data.companyId = companyId || '';
            }

            await createBeneficiaryService(data);

            showAlert('Beneficiário adicionado com sucesso', SEVERITY.SUCCESS);
            navigate('/beneficiarios', {replace: true});
            
        } catch (error: any) {
            showAlert(
                error.message || 'Erro ao adicionar beneficiário', 
                SEVERITY.ERROR
            );
        } finally {
            setIsLoading(false);
            setIsSubmitting(false);
        }
    };
    
    useEffect(() => {
        fetchAllData();
    }, [fetchAllData]);

    return (
        <div className="container-show-project">
            <MenuTop />
            <InfoComponent />
            <div className="container-show-project__container">
                <Form 
                    data={formData} 
                    title='Adicionar beneficiário' 
                    onSubmitForm={onSubmitForm} 
                    onCancel={() => navigate('/beneficiario', {replace: true})}
                    isLoading={isLoading}
                />
            </div>
        </div>
    );
}

export default BeneficiaryAdd;